<template>
  <div class="AddressesStage">
    This is an Addresses page.
  </div>
</template>

<script>
export default {
    name: 'addresses',
};
</script>
